import { Injectable } from '@angular/core';
import { SortDescriptor } from '@progress/kendo-data-query';
import { Observable } from 'rxjs';
import { SearchCriteria, SearchResult } from './models/search-result.model';
import { AuthorizeImpersonationRequest } from './models/authorize-impersonation-request';
import { AuthorizeImpersonationResponse } from './models/authorize-impersonation-response';
import { ImpersonationAuthorizationDetailsDto } from './models/impersonation-authorize-details';
import { ImpersonationUserDetails } from './models/impersonation-user-details';
import { UserImpersonationAuth } from './models/user-impersonation-auth.model';
import { CreateImpersonationHistoryRequest } from './models/create-impersonation-history-request';
import { JsonPatchDocument } from './models/json-patch-operation.model';
import { ImpersonationHistoryResponse } from './models/impersonation-history-response';
import { ImpersonationActionLogRequest } from './models/impersonation-action-log.model';

@Injectable()
export abstract class ImpersonationRepository {
  abstract authorizeImpersonation(request: AuthorizeImpersonationRequest): Observable<AuthorizeImpersonationResponse>;
  abstract getImpersonationDetails(): Observable<ImpersonationAuthorizationDetailsDto>;
  abstract getImpersonationEligibleUsers(
    criteria: SearchCriteria,
    sort?: SortDescriptor
  ): Observable<SearchResult<ImpersonationUserDetails>>;
  abstract getUsers(
    criteria: SearchCriteria,
    includeDeleted?: boolean,
    sort?: SortDescriptor
  ): Observable<SearchResult<UserImpersonationAuth>>;
  abstract getConsultantImpersonationUsers(
    criteria: SearchCriteria,
    includeDeleted?: boolean,
    sort?: SortDescriptor
  ): Observable<SearchResult<UserImpersonationAuth>>;
  abstract recordImpersonationHistory(request: CreateImpersonationHistoryRequest): Observable<number>;
  abstract updateImpersonationEndDate(id: number, patchRequest: JsonPatchDocument): Observable<void>;
  abstract getImpersonationHistory(
    authId: number,
    criteria: SearchCriteria
  ): Observable<SearchResult<ImpersonationHistoryResponse>>;
  abstract logImpersonationAction(request: ImpersonationActionLogRequest): Observable<void>;
}
